import React, { useState } from 'react';
import DebugPanel from './DebugPanel';
import { extractRoleInfoFromText, extractSceneInfoFromText } from '../api/scenarioApi';

const DebugPage = () => {
  const [showScenarioDebug, setShowScenarioDebug] = useState(true);
  const [parseTestInput, setParseTestInput] = useState('');
  const [parseResult, setParseResult] = useState(null);
  
  const testParser = () => {
    if (!parseTestInput.trim()) return;
    
    try {
      const result = showScenarioDebug 
        ? extractRoleInfoFromText(parseTestInput)
        : extractSceneInfoFromText(parseTestInput);
      
      setParseResult(result);
    } catch (error) {
      setParseResult({ error: error.toString() });
    }
  };
  
  return (
    <div className="app">
      <h1 className="app-title">API Debug Page</h1>
      <p className="app-subtitle">Test API endpoints for troubleshooting</p>
      
      <div className="card">
        <h2>Select API to Debug</h2>
        <div style={{ margin: '1rem 0', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
          <button 
            onClick={() => setShowScenarioDebug(true)}
            style={{ opacity: showScenarioDebug ? 1 : 0.7 }}
          >
            Scenario Generation API
          </button>
          <button 
            onClick={() => setShowScenarioDebug(false)}
            style={{ opacity: !showScenarioDebug ? 1 : 0.7 }}
          >
            Scene Generation API
          </button>
        </div>
        
        <p style={{ marginTop: '1rem' }}>
          <strong>Test Instructions:</strong><br />
          1. Enter sample context in the format expected by the API<br />
          2. Click "Test API" to see the response<br />
          3. Check the console for additional details
        </p>
        
        {showScenarioDebug ? (
          <>
            <h3>Scenario Generation API Test</h3>
            <p>
              <strong>Expected format:</strong><br />
              <code>
                Question 1: [question text]<br />
                Answer 1: [answer text]<br />
                Question 2: [question text]<br />
                Answer 2: [answer text]<br />
                Question 3: [question text]<br />
                Answer 3: [answer text]
              </code>
            </p>
            <DebugPanel apiEndpoint="https://promptmanager.fly.dev/api/v1/prompts/6/execute" />
          </>
        ) : (
          <>
            <h3>Scene Generation API Test</h3>
            <p>
              <strong>Expected format:</strong><br />
              <code>
                Scenario Description: [detailed scenario description]<br />
                Chosen Role: [role name] - [role description]<br />
                Scene 1: [scene text]<br />
                User Choice 1: [user choice]<br />
              </code>
            </p>
            <DebugPanel apiEndpoint="https://promptmanager.fly.dev/api/v1/prompts/7/execute" />
          </>
        )}
      </div>
      
      {/* Parser Test Section */}
      <div className="card" style={{ marginTop: '2rem' }}>
        <h2>Test Text Parser</h2>
        <p>Paste raw API response text here to test the parser:</p>
        
        <textarea
          value={parseTestInput}
          onChange={(e) => setParseTestInput(e.target.value)}
          style={{
            width: '100%',
            minHeight: '200px',
            margin: '1rem 0',
            fontFamily: 'monospace',
            fontSize: '0.9rem'
          }}
          placeholder={showScenarioDebug 
            ? "Paste raw API text for scenario/roles here to test parsing..."
            : "Paste raw API text for scene/choices here to test parsing..."}
        />
        
        <button 
          onClick={testParser}
          disabled={!parseTestInput.trim()}
          style={{ marginBottom: '1rem' }}
        >
          Test Parser
        </button>
        
        {parseResult && (
          <div style={{ 
            background: 'rgba(20, 20, 40, 0.6)',
            padding: '1rem',
            borderRadius: '8px',
            marginTop: '1rem',
            textAlign: 'left'
          }}>
            <h3 style={{ margin: '0 0 1rem 0' }}>Parser Result:</h3>
            <pre style={{ 
              whiteSpace: 'pre-wrap', 
              wordBreak: 'break-word',
              maxHeight: '300px',
              overflow: 'auto'
            }}>
              {JSON.stringify(parseResult, null, 2)}
            </pre>
          </div>
        )}
      </div>
      
      <div style={{ marginTop: '2rem' }}>
        <button
          onClick={() => window.location.href = '/'}
          style={{ 
            color: '#a288e3', 
            textDecoration: 'none',
            padding: '0.5rem 1rem',
            background: 'transparent',
            border: '1px solid #a288e3',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Return to Main App
        </button>
      </div>
    </div>
  );
};

export default DebugPage;